import { ClientPage } from "../../submodules/rapdv/client/elements/PagesCtrl"
import { StarSelector } from "../elements/star-selector/StarSelector"

export class PageFeedback implements ClientPage {
  private static readonly STAR_SIZE = 32

  getPageId = (): string => "feedback"

  execute = (): void => {
    const ratingElement = document.querySelector(".js-feedback-rater") as HTMLElement | null
    const liveRatingElement = document.querySelector(".js-feedback-live-rating") as HTMLElement | null
    const starsInput = document.querySelector('input[name="stars"]') as HTMLInputElement | null

    if (!ratingElement || !starsInput) return

    const initialRating = parseFloat(starsInput.value)
    const hasInitial = !isNaN(initialRating) && initialRating > 0

    const renderLive = (value: number) => {
      if (!liveRatingElement) return
      liveRatingElement.textContent = value > 0 ? String(value) : ""
    }

    const starSelector = new StarSelector({
      element: ratingElement,
      starSize: PageFeedback.STAR_SIZE,
      step: 1,
      showToolTip: false,
      rating: hasInitial ? initialRating : undefined,
      rateCallback: (rating: number, done: () => void) => {
        starSelector.setRating(rating)
        starsInput.value = String(rating)
        renderLive(rating)
        done()
      },
      onHover: (currentRating: number) => {
        renderLive(currentRating)
      },
      onLeave: (_currentRating: number, rating: number | null) => {
        renderLive(rating ?? 0)
      }
    })

    renderLive(hasInitial ? initialRating : 0)
  }

  onPageClose = (): void => {}
}
